import { fetchFromBusinessCentralEspecial } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

// Función para consultar el stock de un producto en todas las ubicaciones
export const getProductStock = async (itemNo) => {
    if (!isOnline()) {
        console.log("Sin conexión a internet, no se puede consultar el stock");
        throw new Error("Sin conexión a internet");
    }

    if (!itemNo || itemNo.trim() === "") {
        throw new Error("El número de artículo es requerido");
    }

    try {
        console.log(`Consultando stock para el producto: ${itemNo}`);

        // Preparar los datos para la consulta
        const requestData = {
            itemNo: itemNo.trim(),
            locationCode: "" // En blanco para consultar todas las ubicaciones
        };

        // Realizar la consulta al endpoint de Business Central
        const response = await fetchFromBusinessCentralEspecial("Importaciones_getproductostock", requestData);

        if (!response) {
            throw new Error("No se recibió respuesta del servidor");
        }

        // La respuesta viene como un string JSON en response.value
        const stockData = JSON.parse(response);

        if (!stockData.Product_Stock || stockData.Product_Stock.length === 0) {
            return {
                success: false,
                message: "No se encontró información de stock para este producto",
                data: null
            };
        }

        console.log(`Stock consultado exitosamente: ${stockData.Total_Records} ubicaciones encontradas`);

        return {
            success: true,
            message: `Stock consultado exitosamente para ${stockData.Total_Records} ubicaciones`,
            data: {
                productStock: stockData.Product_Stock,
                totalRecords: stockData.Total_Records,
                queryDate: stockData.Query_Date,
                filteredItem: stockData.Filtered_Item,
                filteredLocation: stockData.Filtered_Location
            }
        };

    } catch (error) {
        console.error("Error al consultar el stock del producto:", error);
        throw new Error(`Error al consultar el stock: ${error.message}`);
    }
};

// Función para formatear la información de stock para mostrar
export const formatStockInfo = (stockItem) => {
    return {
        itemNo: stockItem.Item_No,
        description: stockItem.Item_Description,
        description2: stockItem.Item_Description_2,
        unitOfMeasure: stockItem.Base_Unit_of_Measure,
        category: stockItem.Item_Category_Code,
        type: stockItem.Type,
        blocked: stockItem.Blocked,
        locationCode: stockItem.Location_Code || "Sin ubicación",
        locationName: stockItem.Location_Name || "Sin nombre",
        locationAddress: stockItem.Location_Address || "",
        locationCity: stockItem.Location_City || "",
        locationContact: stockItem.Location_Contact || "",
        stockQuantity: stockItem.Stock_Quantity,
        lastUpdateDate: stockItem.Last_Update_Date,
        hasStock: stockItem.Stock_Quantity > 0
    };
};

// Función para obtener el resumen total de stock
export const getStockSummary = (stockData) => {
    if (!stockData || !stockData.productStock) {
        return null;
    }

    const totalStock = stockData.productStock.reduce((sum, item) => sum + item.Stock_Quantity, 0);
    const locationsWithStock = stockData.productStock.filter(item => item.Stock_Quantity > 0).length;
    const locationsWithNegativeStock = stockData.productStock.filter(item => item.Stock_Quantity < 0).length;

    return {
        totalStock,
        totalLocations: stockData.totalRecords,
        locationsWithStock,
        locationsWithNegativeStock,
        productInfo: stockData.productStock[0] ? {
            itemNo: stockData.productStock[0].Item_No,
            description: stockData.productStock[0].Item_Description,
            category: stockData.productStock[0].Item_Category_Code,
            unitOfMeasure: stockData.productStock[0].Base_Unit_of_Measure
        } : null
    };
}; 